import { PrispekPolicies } from './Prispek.Policies';

export const PrismaPolicies = PrispekPolicies;
